import { GoListUnordered, GoProject } from 'react-icons/go';

export const VIEW_MODES = [
  { name: 'swimlane', icon: GoProject },
  { name: 'list', icon: GoListUnordered },
];
export const DEFAULT_VIEW_MODE = VIEW_MODES[1];
export const OPPORTUNITIES = 'opportunities';
export const CAMPAIGNS = 'campaigns';
export const INVOICES = 'invoices';
export const ACCOUNTS = 'accounts';
export const AGREEMENTS = 'agreements';

export const SUBSCRIPTION = 'Subscription';
